export default __webpack_public_path__ + "static/media/addbulkimport.eaf4e23d.svg";